import { AxiosPromise, AxiosStatic } from "axios";
import {
  Portfolio,
  PortfolioPerformanceMetrics,
  GetPortfolioPerformanceParams,
} from "../types/Portfolio";

export const getPortfolio =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (): AxiosPromise<Portfolio[]> =>
    await appAxios.get(`${serverURL}/portfolio-v2`, {
      withCredentials: true,
    });

export const getPortfolioPerformance =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (
    params?: GetPortfolioPerformanceParams
  ): AxiosPromise<PortfolioPerformanceMetrics> => {
    let url = `${serverURL}/portfolio-v2/performance`;

    if (params?.commitmentIds && params.commitmentIds.length > 0) {
      const commitmentIdsParam = params.commitmentIds.join(",");
      url += `?filter[commitmentId]=${commitmentIdsParam}`;
    }

    return await appAxios.get(url, {
      withCredentials: true,
    });
  };
